document.addEventListener('crPickupActivated', function (e) {
  setTimeout(function(){
    console.log('_____')
    window.storePickupSettings.extra_input_1 = '';
    window.storePickupSettings.extra_input_2 = '';
    window.storePickupSettings.extra_input_3 = '';
    
    jqCR('#extra_input_1').rules('remove')
    jqCR('#extra_input_2').rules('remove')
    jqCR('#extra_input_3').rules('remove')
    
  }, 500)
  
})

if (specialProduct14 === true || specialProduct15 === true) {
  delete(stores[0]);
}
if (specialProduct27 === true) {
  //delete(stores[1]);
}
function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}
var t = new Date()
var currentDay = t.getDate();
var currentMonth = t.getMonth();
var currentyear = t.getFullYear();
var weekDay = t.getDay();
var currentHour = t.getHours()

var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  blackoutdatesCollection.push([2024, 11, 23, 'inverted'])
  blackoutdatesCollection.push([2025, 11, 22, 'inverted'])
  //blackoutdatesCollection.push([2023, 11, 31, 'inverted'])
  if (currentDay === 22 && currentMonth === 11 && currentyear === 2025 && currentHour >= 14) {
    picker.set('min', 3)
  }
  if (currentDay === 23 && currentMonth === 11 && currentyear === 2025) {
    picker.set('min', 2)
  }
  /*if (currentDay === 21 && currentMonth === 11 && currentyear === 2024 && currentHour >= 14) {
    blackoutdatesCollection.push([2024, 11, 24])
    blackoutdatesCollection.push([2024, 11, 23])
  }

  if (currentDay > 21 && currentMonth === 11 && currentyear === 2024) {
    blackoutdatesCollection.push([2024, 11, 24])
    blackoutdatesCollection.push([2024, 11, 23])
  }*/
  if (specialProduct36 === true) {    
    console.log('special product 36')
    picker.set('max', 100)    
    picker.set('disable', [true,1, 2,
         //{ from: [2023, 1, 11], to: [2026, 9, 8] },
         { from: [2026, 10, 1], to: [2044, 1, 9] },
     ]);           
  } else
  if (specialProduct37 === true || specialProduct38 === true) {    
    console.log('special product 37/38')
    picker.set('max', 100)    
    picker.set('disable', [true,1, 2,
         { from: [2023, 1, 11], to: [2026, 9, 6] },
         { from: [2026, 10, 1], to: [2044, 1, 9] },
     ]);           
  } else
  if (specialProduct39 === true) {    
    console.log('special product 39')
    picker.set('max', 100)    
    picker.set('disable', [true,1, 2,
         { from: [2023, 1, 11], to: [2026, 9, 29] },
         { from: [2026, 10, 1], to: [2044, 1, 9] },
     ]);           
  } else
  if (specialProduct34 === true) {    
    console.log('special product 34')
    picker.set('max', 100)    
    picker.set('disable', [true,1, 2,
         { from: [2023, 1, 11], to: [2026, 9, 8] },
         { from: [2026, 9, 11], to: [2044, 1, 9] },
     ]);           
  } else
  if (specialProduct35 === true) {    
    console.log('special product 35')
    picker.set('max', 100)    
    picker.set('disable', [true,1, 2,
         { from: [2023, 1, 11], to: [2026, 9, 1] },
         //{ from: [2026, 8, 6], to: [2044, 1, 9] },
     ]);           
  } else
  if (specialProduct36 === true) {    
    console.log('special product 36')
    picker.set('max', 100)    
    picker.set('disable', [true, 1, 2,
         { from: [2023, 1, 11], to: [2026, 8, 28] },
         //{ from: [2026, 1, 15], to: [2044, 1, 9] },
     ]);           
  } else

  if (specialProduct26 === true) {    
    console.log('special product 26')
    picker.set('max', 100)    
    picker.set('disable', [true,1, 2,
         { from: [2023, 1, 11], to: [2026, 1, 2] },
         { from: [2026, 1, 15], to: [2044, 1, 9] },
     ]);           
  } else

  if (specialProduct25 === true) {    
    console.log('special product 25')
    picker.set('max', 100)    
    picker.set('disable', [true,1, 2,
         { from: [2023, 1, 11], to: [2026, 1, 5] },
         { from: [2026, 1, 15], to: [2044, 1, 9] },
     ]);           
  } else
  
  if (specialProduct5 === true) {    
    console.log('special product 5')
    picker.set('max', 100)
    // if (currentDay === 21 && currentMonth === 11 && currentyear === 2024 && currentHour >= 14) {
    //   picker.set('min', 7)
    // }

    // if (currentDay > 21 && currentMonth === 11 && currentyear === 2024) {
    //   picker.set('min', 7)    
    // }
    picker.set('disable', [true,
         { from: [2023, 1, 11], to: [2025, 11, 22] },
         { from: [2025, 11, 25], to: [2034, 1, 9] },
     ]);           
  } else
  
  // if (specialProduct23=== true) {    
  //    picker.set('disable', [true, 1, 2,
  //        { from: [2021, 6, 31], to: [2025, 10, 24] },
  //        { from: [2025, 11, 25], to: [2534, 1, 8] }                     
  //    ]);    
  //   picker.set('max', 100)       
  // } else 
  if (specialProduct9=== true) {    
     picker.set('disable', [true, 1,
         { from: [2021, 6, 31], to: [2026, 1, 2] },
         { from: [2026, 2, 4], to: [2044, 1, 8] }  
                   
     ]);           
  } else 
  if (specialProduct20=== true) {    
     picker.set('disable', [true, 1, 2,
         { from: [2021, 6, 31], to: [2026, 4, 7] },
         { from: [2026, 4, 10], to: [2034, 1, 8] }  
                   
     ]);           
  } else 
  if (specialProduct19 === true) {    
     picker.set('disable', [true, 1, 2,
         //{ from: [2021, 6, 31], to: [2025, 3, 18] },
         { from: [2025, 3, 20], to: [2034, 1, 8] }  
                   
     ]);           
  } else 
  if (specialProduct18 === true) {    
     picker.set('disable', [true, 1, 2,
         { from: [2021, 6, 31], to: [2025, 3, 4] },
         { from: [2025, 3, 21], to: [2034, 1, 8] }  
                   
     ]);           
  } else 
  if (specialProduct17 === true) {    
     picker.set('disable', [true, 1, 2,
         { from: [2021, 6, 31], to: [2026, 3, 30] },
         { from: [2026, 4, 10], to: [2034, 1, 8] }  
                   
     ]);           
  } else 
  if (specialProduct16 === true) {    
     picker.set('disable', [true, 1, 2,
         { from: [2021, 6, 31], to: [2026, 3, 27] },
         { from: [2026, 4, 10], to: [2044, 1, 8] }  
                   
     ]);           
  } else 
  if (specialProduct3 === true) {    
     picker.set('disable', [1,2,3,4, 5]);           
  } else if (specialProduct12 === true) {    
     picker.set('disable', [true, 1, 2,
         { from: [2021, 6, 31], to: [2025, 2, 24] },
         { from: [2025, 3, 6], to: [2034, 1, 8] }  
                   
     ]);           
  } else if (specialProduct10 === true) {    
     picker.set('disable', [true, 1, 2,
         { from: [2021, 6, 31], to: [2025, 0, 31] },
         { from: [2025, 1, 15], to: [2034, 1, 8] }  
                   
     ]);           
  } else if (specialProduct11 === true) {    
     picker.set('disable', [true, 1, 2,
         { from: [2021, 6, 31], to: [2025, 1, 7] },
         { from: [2025, 1, 15], to: [2034, 1, 8] }  
                   
     ]);           
  } else {
    picker.set('disable', blackoutdatesCollection);            
  }
}

document.addEventListener('crJQActivated', function (e) {
  if (specialProduct2 === true && specialProduct27 === true) {
      console.log('Disable')
      disableCheckoutButton();
      var tt = setInterval(function(){disableCheckoutButton();}, 1000);
      setTimeout(function() { clearInterval(tt); }, 5000);  
      jqCR('#pickup-container').remove()
//      jqCR('.cr-message').text('Some items in your cart are unavailable for the selected pick up date').removeClass('hide')
      jqCR('.cr-message').text('Items in your cart must be ordered separately').removeClass('hide')
  }  

})



var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  console.log(selectedDay, selectedDate.getDate(), selectedMonth);
  if(selectedDate.getDate() === 24 && selectedDate.getFullYear() === 2023 && selectedMonth === 11) {
    timepicker.set('max',[15, 0]); 
  }
  
  if(selectedDate.getDate() === 31 && selectedDate.getFullYear() === 2024 && selectedMonth === 11) {
    timepicker.set('max',[14, 30]); 
  }
  if(specialProduct15 === true) {
    timepicker.set('min',[11, 0]); 
  	timepicker.set('max',[14, 0]); 
  }
	
}

